export default __webpack_public_path__ + "static/media/02_formatting_file.6b9992cc.png";